import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

const NotFoundPage = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center p-8">
        <h1 className="text-6xl font-bold text-gray-800 mb-4">{t('errorPages.notFound.title')}</h1>
        <h2 className="text-2xl font-semibold text-gray-600 mb-4">
          {t('errorPages.notFound.subtitle')}
        </h2>
        <p className="text-gray-500 mb-8">
          {t('errorPages.notFound.description')}
        </p>
        <Link 
          to="/"
          className="inline-block px-6 py-3 bg-primary text-white rounded-lg hover:bg-secondary transition-colors"
        >
          {t('errorPages.notFound.backHome')}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;